
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doe-dagen",
      function () {
        return require("private-next-pages/doe-dagen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doe-dagen"])
      });
    }
  